module.exports = {
    tcVideoAppID: '1257107998',
    fileReaderChunkSize: 1024 * 1024
}